import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import api from '@/services/apiClient';
import Input from '@/components/ui/Input';
import Select from '@/components/ui/Select';
import Textarea from '@/components/ui/Textarea';
import Button from '@/components/ui/Button';

const TYPES = ['avaliacao', 'aula', 'online', 'outro'];

const empty = { studentId: '', scheduledAt: '', type: 'aula', notes: '' };

export default function AppointmentForm({ onSubmit, onCancel }) {
  const { t } = useTranslation();
  const [form, setForm] = useState(empty);
  const [students, setStudents] = useState([]);
  const [saving, setSaving] = useState(false);
  const [err, setErr] = useState(null);

  useEffect(() => {
    api
      .get('/students')
      .then((res) => setStudents((res.data || res).students || res.data || []))
      .catch(() => setStudents([]));
  }, []);

  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    if (!form.studentId) return setErr(t('agenda.selectStudent'));
    if (!form.scheduledAt) return setErr(t('agenda.datetime'));
    setSaving(true);
    setErr(null);
    const payload = {
      studentId: form.studentId,
      scheduledAt: new Date(form.scheduledAt).toISOString(),
      type: form.type,
      notes: form.notes || undefined,
    };
    try {
      await onSubmit(payload);
    } catch (e2) {
      setErr(e2.message);
      setSaving(false);
    }
  };

  const typeOptions = TYPES.map((v) => ({ value: v, label: t(`agenda.types.${v}`) }));

  return (
    <form onSubmit={submit} style={{ display: 'grid', gap: 'var(--space-4)' }}>
      <Select
        label={t('agenda.student')}
        value={form.studentId}
        onChange={set('studentId')}
        placeholder={t('agenda.selectStudent')}
        options={students.map((s) => ({ value: s.id, label: s.name }))}
      />
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 'var(--space-3)' }}>
        <Input
          label={t('agenda.datetime')}
          type="datetime-local"
          value={form.scheduledAt}
          onChange={set('scheduledAt')}
        />
        <Select label={t('agenda.type')} value={form.type} onChange={set('type')} options={typeOptions} />
      </div>
      <Textarea
        label={t('agenda.notes')}
        value={form.notes}
        onChange={set('notes')}
        rows={3}
        placeholder={t('agenda.notesPlaceholder')}
      />
      {err && <span style={{ color: 'var(--danger)', fontSize: 13 }}>{err}</span>}
      <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 12 }}>
        <Button type="button" variant="ghost" onClick={onCancel}>{t('common.cancel')}</Button>
        <Button type="submit" loading={saving}>{t('agenda.create')}</Button>
      </div>
    </form>
  );
}
